export default __webpack_public_path__ + "static/media/central_andes_1_5.e42ba35a.JPG";